import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface ClientPracticeMessagesMarkAsSeenApiOptions {
  messagesIds: number[];
}

export function clientPracticeMessagesMarkAsSeenApi(path: string) {
  return {
    path,
    PATCH: (params: ClientPracticeMessagesMarkAsSeenApiOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
